<script>
    export let card = {
        header: "",
        content: ""
    };
</script>

<main>
    <div id="card-main" class="mx-auto border border-gray-400 rounded-card bg-white shadow-md">
        <div class="w-full h-full relative p-2">
            <img class="absolute stampIcon" src="stamp.png" alt="Postage Stamp">
            <input id="header" bind:value={card.header} class="w-5/6 float-left pb-6 text-purple-700 outline-none placeholder-purple-700" type="text" placeholder="Header"/>
            <textarea id="content" bind:value={card.content} class="h-auto w-5/6 float-left text-black outline-none placeholder-black" rows="8" maxlength="280" placeholder="Message"/>
        </div>
    </div>
</main>

<style>
    .stampIcon {
        right: min(2.7vw, 20px);
        top: min(2.7vw, 20px);
        width: 7vw;
        max-width: 64px; 
    }

    #card-main {
        width: 82.5vw;
        height: 54vw;
        max-width: 6.25in;
        max-height: 4.5in;
    }

    #header {
        font-size: min(max(2.9vw, 1.4rem), 43px);
        margin-top: 1vw;
        margin-bottom: 0.5vw;
        padding-left: 2vw;
    }

    #content {
        font-size: min(max(1.4vw, 0.9rem), 20px);
        height: max(15vw, 115px);
        resize: none;
        padding-top: 1vw;
        padding-left: 2vw;
        line-height: max(1.5vw, 14px);
    }
</style>